import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from '../auth/AuthContext';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'anon') return <Navigate to="/login" replace />;
  return <>{children}</>;
}
